export const MEDIA_TYPE_VIDEO = 1;
export const MEDIA_TYPE_IMAGE = 2;
export const MEDIA_TYPE_POLISH = 3;
export const MEDIA_TYPE_3D_MODEL = 5;
export const MEDIA_TYPE_I3D_REPORT_POLISH = 6;
export const MEDIA_TYPE_I3D_COMPARATIVE_REPORT_POLISH = 7;
